module.exports = __webpack_public_path__ + "toBride2-we-r-n.8779918b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-r-n.jpg
// module id = 7RfG
// module chunks = 0